export default __webpack_public_path__ + "fonts/TaxDelinquency-White.svg";